<template>
    <div class="box box-primary">
        <div class="box-header with-border">
            <h3 class="box-title">Filter</h3>
            <div class="box-tools pull-right">
                <button
                    class="btn btn-box-tool"
                    title="Collapse"
                    type="button"
                    @click="toggleCollapse"
                >
                    <i
                        :class="changeIcon(collapse)"
                        class="fa"
                    ></i>
                </button>
            </div>
        </div>
        <!-- /.box-header -->
        <vue-slide-up-down
            :active="collapse"
            :duration="durationCollapse"
        >
            <div class="box-body">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <form
                            action=""
                            method="get"
                            role="form"
                            @submit.prevent="newQueryURL"
                        >
                            <div class="row">
                                <DateRangeComponentVue
                                    id="filter_dates"
                                    :disabled="enableFilter.disableWrapper"
                                    :end="endDate"
                                    :start="startDate"
                                    class-input="form-control"
                                    class-main-block="form-group col-xs-12 col-sm-4 col-lg-4"
                                    placeholder="Dates Range"
                                    :title="inputTitle"
                                    @change="changeDate"
                                />
                                <div
                                    :class="enableFilter.disableWrapper"
                                    class="form-group col-xs-12 col-sm-4 col-lg-4"
                                    @click="preventEnter"
                                    @keydown="preventEnter"
                                >
                                    <label class="col-xs-12 hidden-xs">&nbsp;</label>
                                    <button
                                        :class="enableFilter.disableBtn"
                                        class="btn btn-sm btn-primary"
                                        type="submit"
                                    >
                                        Apply
                                    </button>
                                    <a
                                        :class="enableFilter.disableBtn"
                                        :href="getPath()"
                                        class="btn btn-sm btn-info"
                                        @click.prevent="clearFilter"
                                    >
                                        Clear
                                    </a>
                                </div>
                            </div>
                        </form>
                        <div
                            v-if="filterErrors"
                            class="form-group has-error"
                        >
                            <span
                                class="help-block"
                                v-text="filterErrors"
                            ></span>
                        </div>
                    </div>
                </div>
            </div>
        </vue-slide-up-down>
        <!-- /.box-body -->
    </div>
    <!-- /.box -->
</template>

<script>
import DateRangeMixin from '../mixins/date-range-mixin';
import DateRangeComponentVue from '@/components/partials/DateRangeComponentVue';

export default {
    components: {
        DateRangeComponentVue,
    },
    mixins: [DateRangeMixin],
    props: {
        enableFilter: {
            type: Object,
            default: () => ({}),
        },
        defaultRange: {
            type: String,
            default: '',
        },
        filterErrors: {
            type: String,
            default: '',
        },
        inputTitle: {
            type: String,
            default: 'Dates',
        },
    },
    data() {
        return {
            inputName: 'filter',
            inputValue: '',
            startDate: this.formatDate(new Date()),
            endDate: this.formatDate(new Date()),
            localeData: {
                format: 'yyyy-mm-dd',
                firstDay: 0,
            },
            collapse: false,
            durationCollapse: 700,
            currentDate: this.$route.query['filter[dates]'],
        };
    },
    mounted() {
        if (this.currentDate) {
            this.collapse = true;
            this.queryProcess();
        } else if (this.defaultRange) {
            this.collapse = true;
            this.setDefaultRange();
        }
    },
    methods: {
        setDefaultRange: function () {
            let [startDate, endDate] = this.getDefaultRangeDates();
            this.startDate = this.formatDate(startDate);
            this.endDate = this.formatDate(endDate);
        },
        preventEnter: function (event) {
            if (this.enableFilter.preventEnterFilter) {
                return event.preventDefault();
            }
        },
        queryProcess: function () {
            let values = this.$route.query['filter[dates]'];
            let dateRegexp = /\d{4}-\d{2}-\d{2}\s-\s\d{4}-\d{2}-\d{2}/;
            if (dateRegexp.test(values)) {
                let dates = values.split(' - ');
                this.startDate = dates[0];
                this.endDate = dates[1];
            }
        },
        formatDate: function (value) {
            if (value) {
                return window.moment(value.toISOString()).format('YYYY-MM-DD');
            }
        },
        newQueryURL: function () {
            return this.$router
                .push({
                    path: this.getPath(),
                    query: {
                        'filter[dates]':
                            window.moment(this.startDate).format('YYYY-MM-DD') + ' - ' + window.moment(this.endDate).format('YYYY-MM-DD'),
                        'page': String(1),
                    },
                })
                .catch(() => {});
        },
        clearFilter: function () {
            this.setDefaultRange();

            return this.$router.push({ path: this.getPath() }).catch(() => {});
        },
        getPath: function () {
            return this.$route.path;
        },
        changeIcon: function (value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        toggleCollapse: function () {
            this.collapse = !this.collapse;
        },
        changeDate: function (value) {
            let dates = value.split(' - ');
            this.startDate = dates[0];
            this.endDate = dates[1];
        },
    },
};
</script>
